export default "__VITE_ASSET__C_wSj0f4__"